import React, { Component } from "react";
import './LuLaStepper.css';

const STEPS = [
  { number: 1, label: "Datum och tid" },
  { number: 2, label: "Uppgifter" },
  { number: 3, label: "Bekräftelse" },
];

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
);

class LuLaStepper extends Component {
  render() {
    const currentStep = this.props.pCurrentStep;

    return (
      <div className="md3-stepper" data-testid="stepper">
        {STEPS.map((step, index) => {
          const isFinalStep = currentStep >= STEPS.length;
          const isCompleted = step.number < currentStep || isFinalStep;
          const isActive = step.number === currentStep && !isFinalStep;

          let stepClass = "md3-step";
          if (isActive) stepClass += " active";
          if (isCompleted) stepClass += " completed";

          return (
            <React.Fragment key={step.number}>
              {index > 0 && (
                <div className={`md3-step-connector${step.number <= currentStep ? ' completed' : ''}`} />
              )}
              <div className={stepClass} data-testid={`step-${step.number}`}>
                <div className="md3-step-number">
                  {isCompleted ? <CheckIcon /> : step.number}
                </div>
                <span>{step.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default LuLaStepper;
